/* B/C done after already rendered */

var GraphicShapeView = require('../graphic');

module.exports = GraphicShapeView.extend();

/* note: took out btn for selecting edit options -- not used */




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphic/text/text.js
 ** module id = 294
 ** module chunks = 0
 **/